import { render, staticRenderFns } from "./ActivationEmails.vue?vue&type=template&id=6c361b82&scoped=true&"
import script from "./ActivationEmails.vue?vue&type=script&lang=ts&"
export * from "./ActivationEmails.vue?vue&type=script&lang=ts&"
import style0 from "./ActivationEmails.vue?vue&type=style&index=0&id=6c361b82&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c361b82",
  null
  
)

export default component.exports